import type {
  DealLeadDetail,
  DealLeadFieldOptions,
  FieldOption,
  UnmatchedField,
} from '@/types/api'

// An empty list means not loaded yet, so the field falls back to free text.
export function picklistFor(
  options: DealLeadFieldOptions | undefined,
  key: string
): FieldOption[] | null {
  if (!options) return null
  const list = Object.entries(options).find(([name]) => name === key)?.[1]
  return Array.isArray(list) && list.length > 0 ? list : null
}

export function optionLabel(
  options: FieldOption[],
  value: string
): string | null {
  return options.find((option) => option.value === value)?.label ?? null
}

export function unmatchedFor(
  lead: DealLeadDetail,
  key: string
): UnmatchedField | null {
  return lead.unmatchedFields.find((entry) => entry.field === key) ?? null
}

export function unmatchedLabel(reason: UnmatchedField['reason']): string {
  return reason === 'NO_LONGER_IN_DEALCLOUD'
    ? 'No longer in DealCloud'
    : 'Not in DealCloud'
}
